import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WellnessIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="m4.32,7.2c0-1.06.86-1.92,1.92-1.92h11.52c1.06,0,1.92.86,1.92,1.92v7.68h-1.92v-7.68H6.24v7.68h-1.92v-7.68Zm-1.92,9.22c0-.32.26-.58.58-.58h18.05c.32,0,.58.26.58.58,0,1.27-1.03,2.3-2.3,2.3H4.7c-1.27,0-2.3-1.03-2.3-2.3Zm8.64-7.3c0-.26.22-.48.48-.48h.96c.26,0,.48.22.48.48v1.44h1.44c.26,0,.48.22.48.48v.96c0,.26-.22.48-.48.48h-1.44v1.44c0,.26-.22.48-.48.48h-.96c-.26,0-.48-.22-.48-.48v-1.44h-1.44c-.26,0-.48-.22-.48-.48v-.96c0-.26.22-.48.48-.48h1.44v-1.44Z" />
    </SvgIcon>
  )
}
export default WellnessIcon
